import { Button } from "antd";
import { useFirmaCanvas } from "./useFirmaCanvas";
import styles from "../../shared/Evaluaciones.module.css";

export function FirmaCanvas({ rol, nombre, onChange }) {
  const { canvasRef, firmada, iniciar, dibujar, terminar, limpiar } = useFirmaCanvas(onChange);

  return (
    <section className={styles.signatureField}>
      <span className={styles.label}>{rol}</span>
      <strong className={styles.signerName}>{nombre}</strong>
      <div className={styles.canvasFrame}>
        <canvas
          ref={canvasRef}
          width={800}
          height={360}
          aria-label={`Dibujar firma: ${rol}`}
          onPointerDown={iniciar}
          onPointerMove={dibujar}
          onPointerUp={terminar}
          onPointerCancel={terminar}
          onLostPointerCapture={terminar}
        />
        {!firmada && <span className={styles.canvasHint}>Dibuja tu firma aquí</span>}
        <span className={styles.signatureBaseline} />
      </div>
      <div className={styles.signatureFieldFooter}>
        <span>{firmada ? "FIRMA CAPTURADA" : "MOUSE · DEDO · LÁPIZ"}</span>
        <Button type="text" size="small" onClick={limpiar} disabled={!firmada}>
          Limpiar firma
        </Button>
      </div>
    </section>
  );
}
